import React, { useEffect, useState } from "react";
import { CardBody, Col, Container, Row, Card, Button } from "reactstrap";
import BreadCrumb from "../Common/BreadCrumb";
import { MaterialReactTable } from "material-react-table";
import { policyColumns } from "./Constants/PolicyColumns";
import { useDispatch, useSelector } from "react-redux";
import { getAllPolicies } from "../../slices/PartnerMangement/policylist/thunk";
import { Loader } from "../Utils/Loader";
import { policyDataFunction } from "./Constants/ModifyDataFunctions";
import { MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import {
  setEditSuccessMessage,
  setSuccessMessage,
} from "../../slices/toastMessage/action";
import {
  closeModal,
  formattedDatesFunction,
  handleChangeStatus,
  toggleModal,
} from "./Constants/ModifyPolicyDataFunctions";
import CommonModal from "../Utils/CommonModal";
import { PAGE_TITLES } from "../Common/constants";
import { handleExportData } from "../Utils/ExportToCsv";
import { handleExportDataForPolicy } from "./Constants/HandleExportDataForPolicy";
import { useColumnSettings } from "../Utils/useColumnSettings";
import { getView } from "../../slices/View/thunk";
import { hasPermission } from "../Utils/UtilityFunctions";

import { fetchAllOffers } from "../../slices/offer/thunk";
import { fetchAllPartner } from "../../slices/PartnerMangement/thunk";

export const PolicyListing = () => {
  const [loading, setLoading] = useState(false);
  const [globalFilter, setGlobalFilter] = useState("");
  const [columnFilters, setColumnFilters] = useState([]);
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const partnerId = {
    isEdit: false,
  };

  useEffect(() => {
    dispatch(fetchAllOffers(setLoading));
    dispatch(fetchAllPartner(setLoading));
    dispatch(getAllPolicies(setLoading));
    dispatch(getView(setLoading));
  }, [dispatch]);

  const PartnerData = useSelector((state) => state.Partner.partner);
  const offerData = useSelector((state) => state.Offer.offer);
  const fetchPolicies = useSelector((state) => state.PolicyList.policyList);
  // Prepare lookup maps
  const offerMap = offerData.reduce((acc, offer) => {
    acc[offer.offerCode] = offer.offerName; 
    return acc;
  }, {});

  const partnerMap = PartnerData.reduce((acc, partner) => {
    acc[partner.id] = partner.name; 
    return acc;
  }, {});

  // Transform list API data
  const fetchAllPolicies = fetchPolicies.map((item) => ({
    ...item,
    offerNames: item.offers.map((code) => offerMap[code] || code),
    partnerNames: item.partners.map((id) => partnerMap[id] || id),
  }));

  const policyListData = policyDataFunction(fetchAllPolicies);
  const formattedDates = formattedDatesFunction(fetchAllPolicies);
  const columns = policyColumns(formattedDates);
  const showSuccessMessage = useSelector(
    (state) => state.SuccessToast.showSuccessMessage
  );
  const showEditSuccessMessage = useSelector(
    (state) => state.SuccessToast.showEditSuccessMessage
  );

  const rawPermissions = useSelector(
    (state) => state.permissions.permissionsMap
  );

  const permissionsMap = new Map(
    rawPermissions.map(([key, value]) => [key, new Set(value)])
  );
  const policyPermission = hasPermission(permissionsMap, "partners", "commissionPolicy")
  const viewPermission = hasPermission(permissionsMap, "miscellaneous", "view")

  useEffect(() => {
    dispatch({ type: "CLEAR_OFFERS" });
    if (showSuccessMessage) {
      toast.success("Policy Created Successfully");
      dispatch(setSuccessMessage(false));
    }
    if (showEditSuccessMessage) {
      toast.success("Policy Updated Successfully");
      dispatch(setEditSuccessMessage(false));
    }
  }, [showSuccessMessage, showEditSuccessMessage, dispatch]);

  const [modal, setModal] = useState(false);
  const [policyId, setpolicyId] = useState("");

  useEffect(() => {
    const filteredData = policyListData.filter((row) => {
      const globalFilterLower = globalFilter.toLowerCase();
      const columnFilterChecks = columnFilters.map((filter) => {
        const filterValue = filter?.value?.toLowerCase();
        const cellValue = row[filter.id]?.toString().toLowerCase();
        return cellValue?.includes(filterValue);
      });
      const matchesGlobalFilter =
        !globalFilter ||
        (row.id &&
          typeof row.id === "string" &&
          row.id.toLowerCase().includes(globalFilterLower)) ||
        (row.name &&
          typeof row.name === "string" &&
          row.name.toLowerCase().includes(globalFilterLower)) ||
        (row.priority &&
          typeof row.priority === "string" &&
          row.priority.toLowerCase().includes(globalFilterLower)) ||
        (row.partner &&
          Array.isArray(row.partner) &&
          row.partner.some(
            (partner) =>
              typeof partner === "string" &&
              partner.toLowerCase().includes(globalFilterLower)
          )) ||
        (row.offer &&
          Array.isArray(row.offer) &&
          row.offer.some(
            (offer) =>
              typeof offer === "string" &&
              offer.toLowerCase().includes(globalFilterLower)
          )) ||
        (row.formattedDates &&
          typeof row.formattedDates === "string" &&
          row.formattedDates.toLowerCase().includes(globalFilterLower)) ||
        (row.createdBy &&
          typeof row.createdBy === "string" &&
          row.createdBy.toLowerCase().includes(globalFilterLower));

      return matchesGlobalFilter && columnFilterChecks.every(Boolean);
    });
    setData(filteredData);
  }, [globalFilter, columnFilters, policyListData]);

  const handleCancel = () => {
    setGlobalFilter("");
    setColumnFilters([]);
    setData(policyListData);
  };

  const handleGlobalFilterChange = (filter) => {
    setGlobalFilter(filter);
    if (!filter) {
      handleCancel();
    }
  };

  const {
    settingsModalOpen,
    viewColumns,
    toggleSettingsModal,
    CustomViewModal,
  } = useColumnSettings("commissionPolicy", columns);

  return (
    <React.Fragment>
      <div id="csms" className="page-content">
        <Container fluid>
          {loading && <Loader />}
          <BreadCrumb
            title={PAGE_TITLES.SETTLEMENT_POLICY_LIST}
            pageTitle={PAGE_TITLES.PARTNER_LIST}
          />
          <Row>
            <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between w-100">
              <div className="d-flex flex-column flex-md-row">
                <h5 className="rv-page-title p-1">
                  {"Settlement Policy List"}
                </h5>
              </div>
              <div className="d-flex align-items-center">
                {policyPermission && policyPermission?.has("export") &&
                  <Button
                    className="btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap mx-1"
                    onClick={() => {
                      handleExportDataForPolicy(fetchAllPolicies);
                    }}
                  >
                    <i className="ri-download-line label-icon secondary-label-icon align-middle fs-16 me-2 fw-bold"></i>
                    <span className="px-2 ps-3 ms-2 me-1 fw-bold">Export</span>
                  </Button>}
                {policyPermission &&
                  policyPermission?.has("create") ? (
                  <Button
                    className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap mx-1"
                    onClick={() => {
                      navigate("/offer-for-policy", { state: partnerId });
                      dispatch({ type: "CLEAR_PARTNERS" });
                      dispatch({ type: "CLEAR_OFFERS" });
                    }}
                  >
                    <i className="ri-add-fill label-icon align-middle fs-16 me-1 fw-bold"></i>
                    <span className="ps-2 ms-2 me-1 fw-bold">
                      {"Add Settlement Policy"}
                    </span>
                  </Button>
                ) : null}
                {viewPermission && viewPermission?.has("view") &&
                  <div
                    color="secondary"
                    className="btn-icon cursor-img"
                    onClick={toggleSettingsModal}
                  >
                    <i className="ri-settings-2-line fs-4"></i>
                  </div>}
              </div>
            </div>
            <Col lg={12}>
              <ToastContainer position="top-center" />
              <div className="mb-3 mt-1 mx-1 border table-responsive">
                <MaterialReactTable
                  displayColumnDefOptions={{
                    "mrt-row-actions": {
                      header: "",
                      enableHiding: true,
                      size: 52,
                      grow: true,
                    },
                  }}
                  defaultColumn={{
                    minSize: 10,
                    maxSize: 9001,
                    muiTableBodyCellProps: {
                      sx: {
                        fontFamily: "Inter,sans-serif",
                      },
                    },
                    muiTableHeadCellProps: {
                      sx: {
                        fontFamily: "Inter,sans-serif",
                      },
                    },
                  }}
                  initialState={{
                    columnVisibility: {
                      policy: false,
                    },
                  }}
                  manualFiltering
                  onColumnFiltersChange={setColumnFilters}
                  onGlobalFilterChange={handleGlobalFilterChange}
                  state={{ globalFilter, columnFilters }}
                  enableRowActions
                  enableDensityToggle={false}
                  enableColumnActions={true}
                  enableTopToolbar={false}
                  renderRowActionMenuItems={({ row, closeMenu }) => [
                    policyPermission &&
                      policyPermission?.has("update") ? (
                      <MenuItem
                        onClick={() => {
                          navigate(`/update-policy/${row.original.id}`);
                          dispatch({ type: "CLEAR_PARTNERS", payload: [] });
                          dispatch({ type: "CLEAR_OFFERS", payload: [] });
                        }}
                      >
                        <i className="ri-edit-box-line me-2"></i>Edit
                      </MenuItem>
                    ) : null,
                    policyPermission &&
                      policyPermission?.has("delete") ? (
                      <MenuItem
                        onClick={() => {
                          closeMenu();
                          toggleModal(row, setpolicyId, setModal);
                          closeModal(setModal, modal);
                        }}
                      >
                        <i className="ri-delete-bin-line me-2" /> Delete
                      </MenuItem>
                    ) : null,
                  ]}
                  columns={columns.filter((column) =>
                    viewColumns?.includes(column.accessorKey || column.header)
                  )}
                  data={data}
                />
              </div>
            </Col>
            {CustomViewModal()}
          </Row>
        </Container>
        <CommonModal
          open={modal}
          toggle={() => closeModal(setModal, modal)}
          buttonText={"Yes, Delete It"}
          messageForPopUp={`Are you sure you want to delete policy "${policyId}"?`}
          modalAction={() => {
            handleChangeStatus(dispatch, policyId, setLoading),
              closeModal(setModal, modal);
          }}
          modalHeader="Delete Policy"
        />
      </div>
    </React.Fragment>
  );
};
